import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';

import {
    NavigationLinkDirective,
    ShActionItemComponent,
    ShDashboardNavigationComponent,
    ShFormCheckboxWithDropdownModule,
    ShFormMultiSelectModule,
    ShFormTagListModule,
    ShIconModule,
    ShPageHeaderComponent
} from '@stylehaven/components';
import { DhColumnPickerComponent } from '../column-management/dh-column-picker.component';
import { DigihavenActionBarComponent } from './components/action-bar/action-bar.component';
import { DashboardFastLinksComponent } from './components/dashboard-fast-links/dashboard-fast-links.component';
import { DashboardHeaderComponent } from './components/dashboard-header/dashboard-header.component';
import { DashboardSearchComponent } from './components/dashboard-search/dashboard-search.component';
import { DashboardTitleComponent } from './components/dashboard-title/dashboard-title.component';
import { FilterPanelToggleComponent } from './components/filter-panel-toggle/filter-panel-toggle.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { DigihavenRecordActionGroupComponent } from './components/record-action-group/record-action-group.component';
import { SortInfoComponent } from './components/sort-info/sort-info.component';
import { TableHeaderComponent } from './components/table-header/table-header.component';
import { TranslateOrDefaultPipe } from './pipes/translate-or-default.pipe';

@NgModule({
    declarations: [
        DashboardTitleComponent,
        PaginationComponent,
        TranslateOrDefaultPipe,
        TableHeaderComponent,
        DigihavenActionBarComponent,
        SortInfoComponent,
        DashboardHeaderComponent,
        DashboardSearchComponent,
        DashboardFastLinksComponent,
        DigihavenRecordActionGroupComponent
    ],
    imports: [
        CommonModule,
        ShIconModule,
        ShActionItemComponent,
        TranslateModule,
        ReactiveFormsModule,
        RouterModule,
        ShFormMultiSelectModule,
        ShFormTagListModule,
        ShPageHeaderComponent,
        ShDashboardNavigationComponent,
        ShFormCheckboxWithDropdownModule,
        NavigationLinkDirective,
        DhColumnPickerComponent,
        FilterPanelToggleComponent
    ],
    exports: [
        DashboardTitleComponent,
        PaginationComponent,
        TableHeaderComponent,
        DhColumnPickerComponent,
        TranslateOrDefaultPipe,
        DigihavenActionBarComponent,
        DashboardHeaderComponent,
        DashboardSearchComponent,
        DashboardFastLinksComponent,
        DigihavenRecordActionGroupComponent,
        FilterPanelToggleComponent
    ],
    providers: [TranslateOrDefaultPipe]
})
export class DigihavenElementsModule {}

export * from './components/filter-panel-toggle/filter-panel-toggle.component';
export * from './components/filter-panel-toggle/filter-panel.state';
